/** @jsxImportSource @emotion/react */

import { useTheme } from '@emotion/react';

import useTranslate from '@common/hooks/useTranslate';

export type BadgeVoucherProps = {
  productAlreadyDiscounted?: boolean;
  discount: number;
  voucherCode: string;
};

const translations = {
  'additional X': {
    de_DE: 'Spare bis ${discount}'
  },
  'save X': {
    de_DE: 'Spare bis ${discount}'
  },
  'with code X': {
    de_DE: 'Code: ${voucherCode}'
  }
};

export const BadgeVoucher: React.FC<BadgeVoucherProps> = ({
  discount,
  productAlreadyDiscounted,
  voucherCode
}) => {
  const translate = useTranslate(translations);
  const theme = useTheme();

  const BadgeLabelIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      css={{
        display: 'block',
        height: '100%',
        left: 0,
        position: 'absolute',
        top: 0,
        transform: 'translateX(-98%)',
        width: 'auto'
      }}
      viewBox="0 0 23 25"
    >
      <path
        fill={theme.color.promotion}
        d="m.84 13.84 8.8 9.22c1.09 1.3 2.31 1.93 3.47 1.94H23V0h-9.69c-1.15 0-2.65.63-3.84 1.88L.92 9.95c-2.02 2-.08 3.89-.08 3.89Zm13.25-4a3.03 3.03 0 0 1-.12 4.3 3.06 3.06 0 0 1-4.3-.12 3.03 3.03 0 0 1 .1-4.3 3.06 3.06 0 0 1 4.32.12Z"
      />
    </svg>
  );

  return (
    <div
      css={{
        alignItems: 'stretch',
        display: 'flex',
        marginLeft: '1rem',
        minHeight: '26px',
        position: 'relative'
      }}
    >
      <BadgeLabelIcon />
      <div
        css={{
          alignItems: 'center',
          backgroundColor: theme.color.promotion,
          borderRadius: '0 3px 3px 0',
          color: 'white',
          display: 'inline-flex',
          flexWrap: 'wrap',
          lineHeight: '100%',
          gap: '.25rem',
          padding: '4px 6px 4px 0',
          position: 'relative'
        }}
      >
        <span css={{ color: 'white', fontWeight: 'bold', whiteSpace: 'nowrap' }}>
          {productAlreadyDiscounted
            ? translate('additional X', { discount: `-${discount}%` })
            : translate('save X', { discount: `${discount}%` })}
        </span>{' '}
        |{' '}
        <span css={{ color: 'white', whiteSpace: 'nowrap' }}>
          {translate('with code X', { voucherCode })}
        </span>
      </div>
    </div>
  );
};
